import React, { Component } from 'react'
import { getContentOfferPageAccept, getSonePersonalDetails } from '../../services/vu'
import { getAttributeFromOfferStaticInfo, getOfferApplicationId, getOfferStaticInfoCache } from '../../helpers/offer'
import { getCourseId } from '../../helpers/course'
import { courseStaticInfoCache, getAttributeCourseStaticInfo, getCourseStaticInfoCache, hasSanctions } from '../../helpers/enrolment'
import { isOnboardingCompleted } from '../../helpers/steps'
import { Redirect } from 'react-router-dom'
import { getConfiguration } from '../../helpers/configuration'
import { getProperty } from '../../helpers/properties'
import OfferHeader from '../tags/OfferHeader'
import SanctionCard from '../tags/SanctionCard'

export default class OfferThankYou extends Component {
  constructor(props) {
    super(props)

    this.state = {
      offer: getOfferStaticInfoCache(),
      course: {},
      personalDetails: {},
      status: getAttributeFromOfferStaticInfo('status'),
      outcomeCode: getAttributeFromOfferStaticInfo('outcomeCode'),
      outcomeCodeAccepted: getAttributeFromOfferStaticInfo('outcomeCode').toLowerCase() === 'accept',
      selfManagementEnrolFlag: getAttributeFromOfferStaticInfo('courseSelfManagedEnrolment'),
      pastCourseEarliestAdmissDate: new Date(getAttributeFromOfferStaticInfo('courseEarliestAdmissionDate')) < Date.now(),
      offerApplicationId: getOfferApplicationId(),
      processed: getAttributeFromOfferStaticInfo('outcomeCode').toLowerCase() !== 'accept',
      loading: true,
      enrolOpen: false,
      courseYearMatches: false,
      deferralPeriod: getAttributeFromOfferStaticInfo('deferStudyPeriodCode'),
      headerTitle: ''
    }
  }

  componentDidMount() {
    if (this.state.outcomeCodeAccepted && !this.state.processed) {
      getSonePersonalDetails().then(personalDetails => {
        let course = getCourseStaticInfoCache()
        this.stopLoading({
          course: course,
          enrolOpen: course.isEnrolOpen,
          courseYearMatches: course.enrolmentYears && course.enrolmentYears.includes(getAttributeFromOfferStaticInfo('courseYear')),
          processed: course.isStudyPlanExpanded,
          personalDetails: personalDetails
        })
      })
    } else {
      Promise.all([getContentOfferPageAccept(getAttributeFromOfferStaticInfo('courseExpectedStartDate')), getSonePersonalDetails()])
        .then(([offerPageInformation, personalDetails]) => {
          let deferralPeriod = offerPageInformation.deferralPeriods.periods
            .filter(deferralPeriod => deferralPeriod.code === getAttributeFromOfferStaticInfo('deferStudyPeriodCode'))
            .map(deferralPeriod => {
              return deferralPeriod.display
            })[0]
          this.stopLoading({
            deferralPeriod: deferralPeriod,
            personalDetails: personalDetails
          })
        })
        .catch(error => {
          this.setState({
            loading: false,
            error: true
          })
        })
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // if (this.state.loadCourseDetails && !prevState.loadCourseDetails) {
    //   this.getCourseDetails()
    // }
  }

  stopLoading = (newState = {}) => {
    this.setState({
      loading: false,
      ...newState
    })
  }

  generateMessageDiv = (message = 'Your response has been successfully updated, thank you. You will receive further information via email') => {
    return (
      <div className="row">
        <div className="col-xs-12">
          <div className="step-1">
            <p className="txt-lg">{message}</p>
          </div>
        </div>
      </div>
    )
  }

  handleHeaderTitle = (outcome) => {
    switch (outcome) {
      case 'decline':
        return 'Sorry to see you go!'
        break;
      case 'defer':
        return 'See you soon!'
      case 'accept':
        return 'Congratulations!'
      default:
        return 'Something went wrong'
        break;
    }
  }

  handleErrorSubmission = errorMessage => {
    alert(errorMessage)
  }

  render() {
    return this.state.loading ? null : (
      <OfferHeader title={this.handleHeaderTitle(this.state.outcomeCode.toLowerCase())}>
        {()=> {
          if (this.state.error) {
            this.handleErrorSubmission('Unable to process offer acceptance, please contact VUHQ')
            return this.generateMessageDiv('Unable to process offer acceptance, please contact VUHQ')
          }
    
          if (this.state.outcomeCode.toLowerCase() === 'decline') {
            return this.generateMessageDiv('Your response has been successfully updated, thank you. If you require any further information, please contact VUHQ')
          }
    
          if (this.state.outcomeCode.toLowerCase() === 'defer') {
            return (
              <div className="row">
                <div className="col-xs-12">
                  <div className="step-1">
                    <p className="txt-lg">
                      Thanks for submitting a deferment request of your offer in <b>{this.state.offer.courseTitle}</b> for a period of <b>{this.state.deferralPeriod}</b>.
                    </p>
                    <p className="txt-lg">Once your application for deferment has been accepted you will receive confirmation via your VU student email account.</p>
                    <p className="txt-lg">
                      As you approach the end of your deferment, please remember to log back into <a href="https://myvu.edu.au"> MyVU </a> to secure your place.
                    </p>
                  </div>
                </div>
              </div>
            )
          }
    
          if (
            this.state.outcomeCode.toLowerCase() === 'accept' &&
            this.state.selfManagementEnrolFlag &&
            this.state.pastCourseEarliestAdmissDate &&
            this.state.enrolOpen &&
            this.state.courseYearMatches
          ) {
            if (hasSanctions(this.state.personalDetails, getCourseId())) {
              return (
                <div className="row">
                  <div className="col-xs-12">
                    <div className="step-1">
                      <div className="txt-lg">
                        <h2>Your offer response has been processed successfully</h2>
                      </div>
                    </div>
                    <div className="step-1">
                      <SanctionCard sanctions={this.state.personalDetails.studentSanctions} courseId={getCourseId()} />
                    </div>
                  </div>
                </div>
              )
            } else {
              return getAttributeCourseStaticInfo('isCommencing') === 'Y' || !isOnboardingCompleted() ? (
                <Redirect to={{ pathname: getConfiguration('publicPath') }} />
              ) : (
                <Redirect
                  to={{
                    pathname: getConfiguration('baseUrl') + '/manage/units/' + getAttributeCourseStaticInfo('availabilityYear')
                  }}
                />
              )
            }
          }
          //return <Redirect to={{ pathname: getProperty('myVuSiteUrl') +'/enrolments/new'}} />
          return this.generateMessageDiv()
        }}
      </OfferHeader>
    )   
  }
}
